import React, { useEffect, useState } from "react";
import MaterialBox from "../../../../components/MaterialBox";
import Grid from "@mui/material/Grid2";
import MaterialTypography from "../../../../components/MaterialTypography";
import MaterialInput from "../../../../components/MaterialInput";
import { CardContent, FormControl, FormControlLabel, FormHelperText, Switch } from "@mui/material";
import MaterialButton from "../../../../components/MaterialButton";
import { useNavigate } from "react-router-dom";

export const MotorBodyTypeForm = ({ onsubmit, editBodyTypeData }) => {
  const navigate = useNavigate();
  const [bodyTypeData, setBodyTypeData] = useState({
    // body type information
    name: "",
    active: true,

    // body type information status
    nameStatus: "unchecked",
  });

  useEffect(() => {
    if (editBodyTypeData) {
      setBodyTypeData((prevData) => ({
        ...prevData,
        ...editBodyTypeData,
        nameStatus: editBodyTypeData.name ? "success" : "unchecked",
      }));
    }
  }, [editBodyTypeData]);

  const handleBodyTypeDataChange = (event) => {
    let bodyTypeState = { ...bodyTypeData };

    const changeAllowed = true;

    if (event) {
      switch (event.target.name) {
        case "name":
          {
            const alphaNLenghthRegex = new RegExp("^([A-Za-z0-9 ]{2,20})$");

            if (alphaNLenghthRegex.test(event.target.value?.trim())) {
              bodyTypeState[event.target.name + "Status"] = "success";
            } else {
              bodyTypeState[event.target.name + "Status"] =
                event.target.value === "" ? "unchecked" : "error";
            }
          }
          break;

          case "active":
            {
              const value = event.target.value;
              bodyTypeState[event.target.name] = value;
            }
            break;

        default:
          break;
      }

      if (changeAllowed) {
        bodyTypeState[event.target.name] = event.target.value;
      }
    }
    setBodyTypeData(bodyTypeState);
  };

  const checkAllFields = () => {
    let allowSubmit = false;
    if (bodyTypeData.nameStatus === "success") {
      allowSubmit = true;
    } else {
      allowSubmit = false;
    }
    return allowSubmit;
  };

  const handleSubmit = () => {
    if (checkAllFields()) {
      onsubmit(bodyTypeData);
    }
  };

  return (
    <div>
      <CardContent sx={{ minHeight: "50vh" }}>
        <MaterialBox>
          <Grid container spacing={2}>
            <Grid size={{ xs: 12, sm: 6 }}>
              <MaterialBox lineHeight={0} display="inline-block">
                <MaterialTypography
                  component="label"
                  variant="caption"
                  fontWeight="bold"
                >
                  Body Type Name*
                </MaterialTypography>
              </MaterialBox>
              <MaterialInput
                name="name"
                placeholder="eg. Hatchback"
                value={bodyTypeData.name}
                onChange={handleBodyTypeDataChange}
                error={bodyTypeData.nameStatus === "error" ? true : false}
                success={bodyTypeData.nameStatus === "success" ? true : false}
              />
              {bodyTypeData.nameStatus === "error" && (
                <FormControl error>
                  <FormHelperText>
                    Name should be maximum 20 characters long and can contain
                    only alphabets
                  </FormHelperText>
                </FormControl>
              )}
            </Grid>

            <Grid size={{ xs: 12, sm: 2 }}>
              <MaterialBox>
                <MaterialTypography
                  component="label"
                  variant="caption"
                  fontWeight="bold"
                >
                  Active
                </MaterialTypography>
              </MaterialBox>
              <FormControlLabel
                control={
                  <Switch
                    name="active"
                    checked={bodyTypeData.active}
                    onChange={(event) =>
                      handleBodyTypeDataChange({
                        target: {
                          name: "active",
                          value: event.target.checked,
                        },
                      })
                    }
                    color="primary"
                  />
                }
                label={
                  <MaterialTypography variant="caption" fontWeight="bold">
                    {bodyTypeData?.active ? "Yes" : "No"}
                  </MaterialTypography>
                }
                sx={{ marginLeft: 0 }}
              />
            </Grid>
          </Grid>
        </MaterialBox>
      </CardContent>
      <MaterialBox
        display="flex"
        justifyContent="space-between"
        alignItems="center"
      >
        <MaterialButton
          sx={{ m: 2 }}
          variant="outlined"
          color="dark"
          onClick={() => {
            navigate("/motor-master/motor-bodyType");
          }}
        >
          Cancel
        </MaterialButton>
        <MaterialButton
          sx={{ m: 2 }}
          variant="gradient"
          color="dark"
          disabled={!checkAllFields()}
          onClick={handleSubmit}
        >
          Submit
        </MaterialButton>
      </MaterialBox>
    </div>
  );
};
